export const NavComponent = ({ navlist }) => {

    const navlinks =  {
        'Home': "/",
        "Catalog": "/catalog",
        "Details": "/details",
        "Wish List": "/wishlist"
    };

    return (
        <nav className="nav-unit">
            { navlist.map((link,i) => (
                <button 
                    className="link-button tr-btn"
                    onClick={() => window.location.href = navlinks[link]} 
                >
                    {link}{i < navlist.length - 1 && " >"}
                </button>
            ))}
        </nav>
    );
}
